module.exports = __webpack_public_path__ + "img/使君子.b8fa8bf3.jpg";